<ng-template #cookieConsentModal>
  <ng-container *transloco="let t">
    <lib-modal
      class="consent-modal"
      [title]="t('cookie_consent_title')"
      [showPrimaryButton]="true"
      [showSecondaryButton]="!this.showCookieSettings"
      [showCloseButton]="false"
      [primaryButtonText]="t('cookie_consent_approve')"
      [secondaryButtonText]="t('cookie_consent_change')"
      (primaryButton)="acceptCookies()"
      (secondaryButton)="openCookieSettings()"
    >
      <div>
        <p>
          {{ t('cookie_consent_bodytext') }}
        </p>
        <a
          target="_blank"
          href="https://www.vinnova.se/om-oss/om-webbplatsen/om-kakor/"
          >{{ t('cookie_consent_read_more') }}</a
        >
      </div>

      @if (showCookieSettings) {
        <div class="change-settings">
          <div>
            <span>{{ t('cookie_consent_always_on') }}</span>
            <button
              type="button"
              vinnova-button-light
              (click)="showRequiredCookiesText = !showRequiredCookiesText"
              class="d-flex gap-3"
            >
              <h4>{{ t('cookie_consent_necessary_cookies') }}</h4>

              <span class="toggle-icon">
                <lib-icon
                  class="icon-chevron"
                  [name]="
                    showRequiredCookiesText ? 'chevron-up' : 'chevron-down'
                  "
                  aria-hidden="true"
                ></lib-icon>
              </span>
            </button>
          </div>
          @if (showRequiredCookiesText) {
            <div class="explanation-text">
              <p>
                {{ t('cookie_consent_necessary_cookies_text') }}
              </p>
            </div>
          }
          <div>
            <lib-toggle
              [textActive]="t('cookie_consent_on')"
              [textInactive]="t('cookie_consent_off')"
              [active]="hasAnalyticsConsent"
              (change)="hasAnalyticsConsent = !hasAnalyticsConsent"
            ></lib-toggle>

            <button
              type="button"
              (click)="showAnalyticsCookiesText = !showAnalyticsCookiesText"
              vinnova-button-light
              class="d-flex gap-3"
            >
              <h4>{{ t('cookie_consent_analytics') }}</h4>
              <span class="toggle-icon">
                <lib-icon
                  class="icon-chevron"
                  [name]="
                    showAnalyticsCookiesText ? 'chevron-up' : 'chevron-down'
                  "
                  aria-hidden="true"
                ></lib-icon>
              </span>
            </button>
          </div>
          @if (showAnalyticsCookiesText) {
            <div class="explanation-text">
              <p>
                {{ t('cookie_consent_analytics_text') }}
              </p>
            </div>
          }
        </div>
      }
    </lib-modal>
  </ng-container>
</ng-template>
